// src/componentes/Login.jsx
import React, { useState } from "react";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import logo from "../logokye.png";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const logIn = async (e) => {
    e.preventDefault();
    setError("");
    const auth = getAuth();

    try {
      await signInWithEmailAndPassword(auth, email, password);
      // Tras login exitoso, vamos al dashboard protegido
      navigate("/app/dashboard", { replace: true });
    } catch (err) {
      console.error("Error de login:", err);
      switch (err.code) {
        case "auth/wrong-password":
          setError("La contraseña es incorrecta. Intenta de nuevo.");
          break;
        case "auth/user-not-found":
          setError("No se encontró un usuario con este correo.");
          break;
        case "auth/invalid-email":
          setError("El correo ingresado no es válido.");
          break;
        default:
          setError("Ocurrió un error al iniciar sesión. Intenta más tarde.");
      }
    }
  };

  return (
    <div className="login-page">
    <div className="login-container">
      <img src={logo} alt="Logo Grupo Inmobiliario" className="login-logo" />
      <h1>Inicio de sesión</h1>
      <form onSubmit={logIn}>
        <div className="form-group">
          <label htmlFor="email">Usuario (email)</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Correo electrónico"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Contraseña</label>
          <input
            type="password"
            id="password"
            name="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        {error && <p className="error-message">{error}</p>}

        <button type="submit" className="login-button">
          Iniciar sesión
        </button>
      </form>
    </div>
    </div>
  );
};

export default Login;
